const styles = (theme, hasMargin) => ({
  boxContainer: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: theme.palette.opacityBackground.main,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    zIndex: 10
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    margin: hasMargin ? '32px 24px 48px 24px' : '32px 0px 48px 0px',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    flexWrap: 'nowrap',
    flex: 1
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center'
  },
  button: {
    height: '56px',
    ...theme.typography['Heading-S-Medium'],
    color: theme.palette.BackgroundWhite.main
  },
  prevButton: {
    color: theme.palette.TypographyPrimary,
    border: `1px solid ${theme.palette.TypographyPrimary}`,
    minWidth: '56px'
  },
  nextButton: {
    backgroundColor: theme.palette.primary.main
  },
  disabledButton: {
    backgroundColor: theme.palette.disabled,
    color: theme.palette.whiteBackground
  },
  questionIcon: {
    width: '56px',
    padding: '16px',
    color: theme.palette.TypographyPrimary,
    border: `1px solid ${theme.palette.TypographyPrimary}`,
    fontSize: '24px'
  }
});

export default styles;
